import type { Theme } from '@mui/material/styles'

/**
 * Calculates the AppBar offset based on device type.
 * @param theme - MUI theme object
 * @param isMobile - true if device is mobile
 * @param isTablet - true if device is tablet
 * @returns spacing string
 */
export function calculateAppbarOffset (theme: Theme, isMobile: boolean, isTablet: boolean): string {
  if (isMobile) {
    return `${theme.spacing(12)}`
  }
  if (isTablet) {
    return `${theme.spacing(14)}`
  }
  return `${theme.spacing(16)}`
}
